import { render, staticRenderFns } from "./x-textarea.vue?vue&type=template&id=99a22ff0&scoped=true&"
import script from "./x-textarea.vue?vue&type=script&lang=js&"
export * from "./x-textarea.vue?vue&type=script&lang=js&"
import style0 from "./x-textarea.vue?vue&type=style&index=0&id=99a22ff0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a22ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('99a22ff0', component.options)
    } else {
      api.reload('99a22ff0', component.options)
    }
    module.hot.accept("./x-textarea.vue?vue&type=template&id=99a22ff0&scoped=true&", function () {
      api.rerender('99a22ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-textarea.vue"
export default component.exports